import { Component, Input } from '@angular/core';

@Component({
	standalone: false,
	selector: 'bt-page-header',
	templateUrl: './page-header.component.html',
	styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent {
	@Input() title = '';
	@Input() subtitle = '';
	@Input() icon = '';
}
